import { ToolBarStandardButtonType } from "../core/components/toolBar";
import { Grid } from "../core/components/grid";
import { Helper } from "../core/util/helper";
import { HTTPService } from "../core/util/httpManager";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import PartsCS from "./partsCS";
import { NotificationHelper } from "../core/util/notificationHelper";
import { AppHelper } from "../appHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { ComponentHelper } from "../core/util/componentHelper";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { FAIcon } from "../core/components/faIcon";
import { EntityParts } from "./parts";
import { AssemblyGroup } from "./editAssemblyGroup";
import { StringKeyDictionary } from "../commonInterfaces";
import React from "react";
export default class CalcPriceField extends React.Component<CalcPriceFieldProps, CalcPriceFieldState>{
    common = new AppHelper();
    private factory = ComponentHelper.createFactory();
    private translation: StringKeyDictionary<string>;

    constructor(props: CalcPriceFieldProps) {
        super(props)
        this.state = {
            treePrice: this.getTreePrice(),
            value: props.value
        }
        this.setEvents();
        this.translation = null;
        this.initApp();
    }

    private onChange = (value: number) => {
        this.setState({ value: value }, () => { this.props.onChange(this.props.field, this.state.value); })
    }

    private setEvents = () => {
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data) => {
            switch (data.command) {
                case "assemblyGroupChange":
                    this.setState({ treePrice: this.getTreePrice() });
                    break;
            }
        })
    }

    private initApp = () => {
        Helper.getTranslations(["Parts.AssemblyGroupPrice"]).then((result) => {
            this.translation = result.Data;
            this.setState({});
        })
    }

    private getTreePrice = (): number => {
        let price = 0;
        const calc = (node: AssemblyGroup): number => {
            if (Helper.hasValue(node) && Helper.hasValue(node.Items) && node.Items.length > 0) {
                let nodePrice: number = 0;
                for (let i = 0; i < node.Items.length; i++) {
                    nodePrice += calc(node.Items[i]);
                }
                return nodePrice;
            } else {
                return ((Helper.getValueOrDefault(node.Amount, 1)) as number) * (Helper.getValueOrDefault(node.Price, 0) as number);
            }
        }
        price = calc(this.props.entity.AssemblyGroup);
        return price;
    }

    private showCalculateButton = () => {
        return !this.props.entity.IsNew && !this.props.disabled && this.state.treePrice > 0 && this.props.entity.AssemblyGroup.Items.length > 0;
    }

    private createNumericTextBox = () => {

        let props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.value;
        props.field.min = 0;
        props.field.format = "0.00";
        props.field.decimals = 2;
        props.disabled = this.props.disabled;
        props.onChange = (field, value) => {
            this.onChange(value);
        }
        return (
            <div style={{ width: "100%" }}>
                <IsNumericTextBox {...props} />
                {this.createInfoText()}
            </div>
        );
    }

    private createInfoText = () => {
        if (!this.showCalculateButton()) {
            return null;
        } else {
            let color = "";
            const diff = (this.state.value - this.state.treePrice);
            if (diff > 0) {
                color = "#1b5e20";
            } else if (diff < 0) {
                color = "#d50000";
            } else {
                color = "#448aff";
            }

            let text: string = "";
            if (Helper.hasValue(this.translation)) {
                text = this.translation["Parts.AssemblyGroupPrice"].replace("{price}", this.state.treePrice.toString());
            }
            return (<div style={{ marginLeft: "3px", margin: "2px" }}><span style={{ color: color }}>{text}</span></div>);
        }
    }

    private createButton = () => {
        if (!this.showCalculateButton()) {
            return null;
        } else {
            return (
                <div data-role="button" key={kendo.guid()} onClick={() => { this.onChange(this.state.treePrice) }} style={{  }}>
                    <FAIcon name={"calculator-alt"} attributes={[""]} />
                </div>
            )
        }
    }

    componentDidUpdate(prevProps: CalcPriceFieldProps) {
        if (this.props.value != this.state.value) {
            this.setState({ value: this.props.value })
        }
    }

    render() {
        return (
            <div style={{ display: "flex" }} className="calc-price-field" data-show-button={this.showCalculateButton()} >
                {this.createNumericTextBox()}
                {this.createButton()}
            </div>
        );
    }
}

interface CalcPriceFieldProps {
    onChange: (field, value) => void;
    field: {
        model: string
    };
    entity: EntityParts;
    value: number;
    disabled: boolean;
}

interface CalcPriceFieldState {
    value: number;
    treePrice: number;
}